import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-5 flex justify-between" }
const _hoisted_4 = { class: "flex flex-col w-1/4" }
const _hoisted_5 = { class: "flex justify-end" }
const _hoisted_6 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-2xl font-bold" }, "Attivita timesheet", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Field, {
            "label-visible": false,
            "onUpdate:modelValue": [
              _ctx.lista.debounceSearch,
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lista.search) = $event))
            ],
            modelValue: _ctx.lista.search,
            placeholder: "Cerca"
          }, null, 8, ["onUpdate:modelValue", "modelValue"])
        ]),
        _createVNode(_component_NextButton, {
          component: "router-link",
          to: {name:'CreaAttivitaTimesheet'},
          class: "py-1 px-3"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Nuovo ")
          ])),
          _: 1
        })
      ]),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([[_ctx.esito ? 'bg-next-bri' : 'bg-next-orange'], "text-white p-3 mb-3 flex justify-between items-center"])
      }, [
        _createTextVNode(_toDisplayString(_ctx.response_message) + " ", 1),
        _createElementVNode("i", {
          class: "icon-x cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.response_message = ''))
        })
      ], 2), [
        [_vShow, _ctx.response_message.length]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Paginator, {
          class: "",
          pagination: _ctx.lista.paginate
        }, null, 8, ["pagination"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_NextTable, {
          class: "rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4",
          cols: _ctx.cols,
          "onUpdate:cols": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cols) = $event)),
          rows: _ctx.lista.rows,
          onOrderUpdate: _ctx.lista.updateCols
        }, _createSlots({ _: 2 }, [
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_3`,
              fn: _withCtx((context) => [
                _createVNode(_component_router_link, {
                  to: {name:'DettaglioAttivitaTimesheet', params:{id:context.context.row.id}},
                  class: "text-center inset-0 absolute flex items-center justify-center"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                  ])),
                  _: 2
                }, 1032, ["to"])
              ])
            }
          })
        ]), 1032, ["cols", "rows", "onOrderUpdate"])
      ]),
      _createVNode(_component_InfiniteLoading, {
        onInfinite: _ctx.lista.fetchNextPage,
        identifier: _ctx.lista.infiniteIdentifier,
        style: {"min-height":"1px"}
      }, {
        complete: _withCtx(() => _cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altre attività.", -1)
        ])),
        _: 1
      }, 8, ["onInfinite", "identifier"])
    ])
  ]))
}